if (!customElements.get('related-products-slider')) {
  customElements.define(
    'related-products-slider',
    class RelatedProductsSlider extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') return;

        const container = this.querySelector('.swiper');
        if (!container) return;

        new Swiper(container, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          scrollbar: {
            el: this.querySelector('.related-products__scrollbar'),
            draggable: true,
            hide: false,
          },
          breakpoints: {
            500: {
              slidesPerView: 2.2,
            },
            800: {
              slidesPerView: 3.2,
            },
            1200: {
              slidesPerView: 4.2,
            },
          },
        });
      }
    },
  );
}
